var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 17C20 17.55 19.55 18 19 18H5C4.45 18 4 17.55 4 17V7C4 6.45 4.45 6 5 6H19C19.55 6 20 6.45 20 7V17ZM12 8.99999C12 9.54999 11.55 9.99999 11 9.99999H8V11H11C11.55 11 12 11.45 12 12V15C12 15.55 11.55 16 11 16H10C10 16.55 9.55 17 9 17C8.45 17 8 16.55 8 16H7C6.45 16 6 15.55 6 15C6 14.45 6.45 14 7 14H10V13H7C6.45 13 6 12.55 6 12V8.99999C6 8.44999 6.45 7.99999 7 7.99999H8V7.98999C8 7.43999 8.45 6.98999 9 6.98999C9.55 6.98999 10 7.43999 10 7.98999V7.99999H11C11.55 7.99999 12 8.44999 12 8.99999ZM14.743 10H17.257C17.4487 10 17.5652 9.82849 17.4608 9.6964L16.2038 8.09167C16.1092 7.96944 15.8908 7.96944 15.7937 8.09167L14.5392 9.6964C14.4348 9.82849 14.5513 10 14.743 10ZM14.743 14H17.257C17.4487 14 17.5652 14.1715 17.4608 14.3036L16.2063 15.9083C16.1092 16.0306 15.8908 16.0306 15.7962 15.9083L14.5392 14.3036C14.4348 14.1715 14.5513 14 14.743 14Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/Pricing.fe7099766d6dd1877f5502abe068437c.svg";
export { ForwardRef as ReactComponent };